import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Process from '../components/Process';
import Technologies from '../components/Technologies';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import LightRays from '../components/LightRays';
import ParticleField from '../components/ParticleField';
import Cursor from '../components/Cursor';

const Home = () => {
  // Global reveal-on-scroll
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in-view'); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal, .reveal-stagger').forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="relative min-h-screen text-white overflow-x-hidden bg-black">
      <LightRays />
      <ParticleField />
      <Cursor />

      <div className="relative z-[3]">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <About />
          <Process />
          <Technologies />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
